var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdnoklassniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x35_9-odnoklassniki"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,255.996c65.789,0,119.301-53.648,119.301-119.627C375.301,70.397,321.789,16.75,256,16.75      c-65.793,0-119.302,53.647-119.302,119.619C136.698,202.348,190.207,255.996,256,255.996L256,255.996z M256,76.557      c32.896,0,59.648,26.827,59.648,59.812c0,32.986-26.752,59.816-59.648,59.816c-32.898,0-59.654-26.83-59.654-59.816      C196.346,103.384,223.102,76.557,256,76.557L256,76.557z M256,76.557",
    style: {
      fill: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.193,252.676c-11.662-11.696-30.516-11.696-42.174,0      c-63.945,64.116-168.037,64.116-232.011,0c-11.658-11.696-30.512-11.696-42.174,0c-11.662,11.69-11.662,30.596,0,42.319      c37.102,37.199,84.134,58.407,132.632,63.932l-85.031,85.265c-11.658,11.694-11.658,30.592,0,42.286      c11.664,11.696,30.51,11.696,42.173,0L256,417.906l68.391,68.571c5.818,5.832,13.447,8.769,21.084,8.769      s15.268-2.937,21.084-8.769c11.662-11.694,11.662-30.592,0-42.286l-85.031-85.265c48.496-5.524,95.531-26.732,132.633-63.932      C425.824,283.295,425.824,264.366,414.193,252.676L414.193,252.676z M414.193,252.676",
    style: {
      fill: "#FFC107"
    }
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdnoklassniki);
export default __webpack_public_path__ + "static/media/odnoklassniki.11ed2f213234cfbf2e2a7a2726a71d95.svg";
export { ForwardRef as ReactComponent };